<template>
  <v-btn
    class="btn-payment ma-0"
    :class="{ 'two-lines': twoLines, 'no-logo': logo === null }"
    :style="'border-color:' + color"
    @click="$emit('click')"
    @touchend="$blurRipple($el)"
  >
    <div>
      <p>
        {{ title }}
      </p>
      <img
        v-if="logo"
        :src="LogoImages[logo]"
        alt="logo"
        class="logo-payment"
      >
    </div>
  </v-btn>
</template>

<script>
import { LogoImages } from '@/modules/Images'
import { $blurRipple } from '@/modules/Utils'

export default {
  name: 'PaymentBtn',

  props: {
    title: { type: String, required: true },
    logo: { type: String, default: null },
    color: { type: String, default: 'grey' },
    twoLines: { type: Boolean, default: false }
  },

  data () {
    return {
      LogoImages
    }
  },

  methods: {
    $blurRipple
  }
}
</script>

<style scoped>
.logo-payment {
  max-width: 80px;
  max-height: 48px;
}
</style>
